import React from 'react'
import { useAuth } from '@/hooks/useAuth'
import KidRequests from '@/components/KidRequests'
import { AvailabilityApprovals } from '@/components/AvailabilityApprovals'
import { ParentKidRequestsView } from '@/components/ParentKidRequestsView'

/**
 * Requests page - Shows kid requests
 * - Kids: Create new requests (haircut, sick, etc.)
 * - Parents: View and approve kid requests + availability overrides
 * Route: /dashboard/requests
 */
export const RequestsPage: React.FC = () => {
  const { user } = useAuth()

  // Parents see pending requests they can approve
  if (user?.is_parent) {
    return (
      <div className="container mx-auto p-6 max-w-4xl">
        <h1 className="text-2xl font-bold mb-6">Kids' Requests</h1>

        <div className="space-y-6">
          {/* Kid "I need something" requests */}
          <ParentKidRequestsView />

          {/* Availability override approvals */}
          <AvailabilityApprovals />
        </div>
      </div>
    )
  }

  // Kids see their own request creation interface
  return <KidRequests />
}
